import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { useApp } from '../contexts/AppProvider';
import ErrorDisplay from '../components/ErrorDisplay';

function MainLayout({ children }) {
	const { isLoading, error, t } = useApp();

	if (isLoading) {
		return (
			<div className="flex flex-col min-h-screen items-center justify-center" style={{ backgroundColor: 'var(--color-bg)' }}>
			<div className="text-center">
				<div className="loading loading-spinner loading-lg" style={{ color: 'var(--color-primary)' }}></div>
				<p className="mt-4" style={{ color: 'var(--color-muted)' }}>{t("loadingApp")}</p>
			</div>
			</div>
		);
	}

	if (error) {
		return <ErrorDisplay statusCode={error.statusCode} detail={error.detail} />;
	}


	return (
		<div className="flex flex-col min-h-screen" style={{ backgroundColor: 'var(--color-bg)' }}>
			<Header />
			<main className="flex-grow">
				<div className="mx-auto" style={{ maxWidth: '1600px' }}>
					{children}
				</div>
			</main>
			<Footer />
		</div>
	);
}

export default MainLayout;